import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'),
    meta: {
      title: '提示'
    }
  },
  {
    path: '/queryList',
    name: 'QueryList',
    component: () => import('../views/QueryList.vue'),
    meta: {
      title: '问卷列表',
      requiresAuth: true
    }
  },
  {
    path: '/query',
    name: 'Query',
    component: () => import('../views/Query.vue'),
    meta: {
      title: store.state.configurationModel?.model.name ?? '问卷',
      requiresAuth: true
    }
  },
  {
    path: '/resultList',
    name: 'ResultList',
    component: () => import('../views/ResultList.vue'),
    meta: {
      title: '测评结果',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/',  // 程序启动默认路由
    redirect: '/home',  // 重定向到首页
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '主页',
      requiresAuth: true
    }
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('../views/Record.vue'),
    meta: {
      title: '测评记录',
      requiresAuth: true
    }
  },
  {
    path: '/record-detail',
    name: 'RecordDetail',
    component: () => import('../views/RecordDetail.vue'),
    meta: {
      title: '记录详情',
      requiresAuth: true
    }
  },
  {
    path: '/description',
    name: 'Description',
    component: () => import('../views/Description.vue'),
    meta: {
      title: '简介',
      requiresAuth: true
    }
  },
  {
    path: '/complete',
    name: 'Complete',
    component: () => import('../views/Complete.vue'),
    meta: {
      title: '完善信息',
      requiresAuth: true
    }
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    meta: {
      title: '',
      requiresAuth: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 解决路由跳转同一地址的报错
const originalPush = router.push
const originalReplace = router.replace
// push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
router.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

// 动态设置标签页标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = store.getters['user/isAuthenticated']
    if (!isAuthenticated) {
      // 用户未登录，存储目标路由
      store.commit('setRedirectTo', to.fullPath);
      next({
        path: '/login',
        query: {
          hospitalId: to.query.hospitalId
        }
      }); // 如果未登录，重定向到登录页面
    } else {
      next(); // 继续导航
    }
  } else {
    next();
  }
  
})

export default router
